import { computeRate, clamp, money, n } from "./rateMath";
import { Section } from "./Section";

const Row = ({ label, value, base, testId, isBase }) => {
  const delta = value - base;
  return (
    <tr className={`border-t border-gray-100 ${isBase ? "bg-gray-50 font-medium" : ""}`} data-testid={testId}>
      <td className="py-1.5 pr-3 text-gray-700">{label}</td>
      <td className="py-1.5 px-3 font-mono text-right">{money(value)}/hr</td>
      <td className={`py-1.5 pl-3 font-mono text-right ${delta > 0.004 ? "text-red-600" : delta < -0.004 ? "text-green-600" : "text-gray-400"}`}>
        {isBase ? "current" : `${delta >= 0 ? "+" : "−"}${money(Math.abs(delta))}`}
      </td>
    </tr>
  );
};

export const SensitivityTable = ({ inputs, result }) => {
  const at = (patch) => computeRate({ ...inputs, ...patch }).trueHourly;
  const util = n(inputs.utilization_pct);
  const down = n(inputs.downtime_weeks);
  const utilRows = [-5, 0, 5].map((d) => ({ d, v: clamp(util + d, 0, 100) }));
  const downRows = [-2, 0, 2].map((d) => ({ d, v: clamp(down + d, 0, 52) }));
  return (
    <Section letter="B" title="Sensitivity" description="How your True Hourly Cost moves if utilization or downtime shifts." testId="rate-calc-sensitivity">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-xs">
        <table className="w-full">
          <tbody>
            {utilRows.map(({ d, v }) => (
              <Row key={d} label={`Utilization ${v}%${d ? ` (${d > 0 ? "+" : ""}${d}%)` : ""}`} value={at({ utilization_pct: v })} base={result.trueHourly} isBase={!d} testId={`sens-util-${d}`} />
            ))}
          </tbody>
        </table>
        <table className="w-full">
          <tbody>
            {downRows.map(({ d, v }) => (
              <Row key={d} label={`Downtime ${v} wks${d ? ` (${d > 0 ? "+" : ""}${d})` : ""}`} value={at({ downtime_weeks: v })} base={result.trueHourly} isBase={!d} testId={`sens-down-${d}`} />
            ))}
          </tbody>
        </table>
      </div>
    </Section>
  );
};
